import React from 'react';
import { NavLink } from 'react-router-dom';

const SVG = ({ children, size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    {children}
  </svg>
);

const TABS = [
  {
    path: '/dashboard',
    label: 'Accueil',
    icon: (
      <SVG>
        <path d="M3 9.5L12 3l9 6.5V20a1 1 0 01-1 1H4a1 1 0 01-1-1V9.5z"/>
        <polyline points="9,21 9,12 15,12 15,21"/>
      </SVG>
    ),
  },
  {
    path: '/recherche',
    label: 'Trouver',
    icon: (
      <SVG>
        <circle cx="11" cy="11" r="7"/>
        <line x1="20" y1="20" x2="16.5" y2="16.5"/>
      </SVG>
    ),
  },
  {
    path: '/live',
    label: 'Live',
    live: true,
  },
  {
    path: '/messages',
    label: 'Messages',
    icon: (
      <SVG>
        <path d="M4 5h16v11H8l-4 4z"/>
      </SVG>
    ),
    badgeKey: 'chatUnread',
  },
  {
    path: '/profile',
    label: 'Profil',
    icon: (
      <SVG>
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
        <circle cx="12" cy="7" r="4"/>
      </SVG>
    ),
  },
];

function Navigation({ chatUnread = 0, liveActive = false }) {
  return (
    <nav className="bottom-nav">
      {TABS.map(tab => tab.live ? (
        <NavLink
          key={tab.path}
          to={tab.path}
          className="nav-item"
          style={{ display: 'flex', flexDirection: 'column', alignItems: 'center',
                   justifyContent: 'center', gap: 4, padding: '6px 0', flex: 1,
                   textDecoration: 'none', color: 'var(--text-3)', cursor: 'pointer',
                   position: 'relative', transition: 'color 0.15s' }}
        >
          {/* ponytail: onglet spécial → fond accent en relief, apparence fixe (jamais de style "active" : cf. .nav-item.active en CSS). Halo rouge pulsant autour le jour J. */}
          <span className={liveActive ? 'nav-live-halo' : undefined} style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                   width: 38, height: 38, borderRadius: '50%', marginTop: -8, color: '#fff',
                   background: 'var(--sun)',
                   boxShadow: '0 4px 12px rgba(20,20,40,0.22)' }}>
            <SVG size={22}>
              <circle cx="12" cy="12" r="10"/>
              <path d="M11.1 7.1a16.55 16.55 0 0 1 10.9 4"/>
              <path d="M12 12a12.6 12.6 0 0 1-8.7 5"/>
              <path d="M16.8 13.6a16.55 16.55 0 0 1-9 7.5"/>
              <path d="M20.7 17a12.8 12.8 0 0 0-8.7-5 13.3 13.3 0 0 1 0-10"/>
              <path d="M6.3 3.8a16.55 16.55 0 0 0 1.9 11.5"/>
            </SVG>
          </span>
          <span style={{ fontSize: 10, fontWeight: 600, letterSpacing: '0.02em' }}>Live</span>
        </NavLink>
      ) : (
        <NavLink
          key={tab.path}
          to={tab.path}
          className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
          style={({ isActive }) => ({ display: 'flex', flexDirection: 'column', alignItems: 'center',
                   justifyContent: 'center', gap: 4, padding: '6px 0', flex: 1,
                   textDecoration: 'none', color: isActive ? 'var(--text)' : 'var(--text-3)', cursor: 'pointer',
                   position: 'relative', transition: 'color 0.15s' })}
        >
          <span style={{ position: 'relative' }}>
            {tab.icon}
            {tab.badgeKey === 'chatUnread' && chatUnread > 0 && (
              <span style={{
                position: 'absolute', top: -3, right: -6,
                minWidth: 16, height: 16, borderRadius: 8, padding: '0 4px',
                background: 'var(--coral)', color: '#fff',
                fontSize: 10, fontWeight: 700,
                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
              }}>{chatUnread > 9 ? '9+' : chatUnread}</span>
            )}
          </span>
          <span style={{ fontSize: 10, fontWeight: 600, letterSpacing: '0.02em' }}>
            {tab.label}
          </span>
        </NavLink>
      ))}
    </nav>
  );
}

export default Navigation;
